import React, { useContext } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select, ListItemText } from '@mui/material';
import { PlayersContext } from './fetch/GetPlayersComponent.js';

export default function SelectPlayer({ players = [], name, selectedPlayer , handleChange }) {

    console.log("Draw SelectPlayer")

    return (
        <FormControl fullWidth>
            <InputLabel>Joueur</InputLabel>
            <Select
                name={name}
                label="Joueur"
                value={selectedPlayer}
                onChange={handleChange}
            >
                {players.sort((a, b) => a.lastname.localeCompare(b.lastname)).map((player) => (
                        <MenuItem key={player._id} value={player._id}>
                            <ListItemText primary={player.lastname + ' ' + player.firstname} />
                        </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}